<template>
    <div>
        <el-dialog title="市场咨询服务合同" :visible.sync="jcxy" :close-on-click-modal="false" width="800px" center>
            <el-form :inline="true" ref="addForm" :model="reqCreate" label-width="100px" :rules="rules">

                <el-form-item label="签署公司（乙方）" prop="signSealId" class="item">
                    <el-select v-model="reqCreate.signSealId" style="width:620px" @change="selectJms" clearable
                        placeholder="请选择签署公司（乙方" filterable>
                        <el-option v-for="(item, index) in allJMSList" :key="index" :label="item.companyName"
                            :value="item.id"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="联系电话" prop="tel">
                    <el-input v-model="reqCreate.tel" style="width:255px" clearable maxlength="11" show-word-limit
                        placeholder="签署公司的联系电话"></el-input>
                </el-form-item>

                <el-form-item label="信用代码" prop="xinyongdaima">
                    <el-input v-model="reqCreate.xinyongdaima" style="width:255px" clearable show-word-limit
                        placeholder="签署公司的三合一社会信用代码"></el-input>
                </el-form-item>

                <el-form-item label="联系地址" prop="address">
                    <el-input v-model="reqCreate.address" style="width:623px" show-word-limit placeholder="签署公司的联系地址"
                        clearable></el-input>
                </el-form-item>

                <el-form-item label="开始日期" prop="dateStart">
                    <el-date-picker v-model="reqCreate.dateStart" style="width:255px" type="date"
                        placeholder="请选择服务开始日期" value-format="yyyy-MM-dd" format="yyyy-MM-dd"></el-date-picker>
                </el-form-item>
                <el-form-item label="截止日期" prop="dateEnd">
                    <el-date-picker v-model="reqCreate.dateEnd" style="width:255px" type="date" placeholder="请选择服务截止日期"
                        value-format="yyyy-MM-dd" format="yyyy-MM-dd"></el-date-picker>
                </el-form-item>

                <el-form-item label="第几年开始收取" prop="nian" class="nian">
                    <el-input v-model="reqCreate.nian" type="number" style="width:255px" clearable show-word-limit
                        placeholder="请输入第几年开始收取"><template slot="append">年</template></el-input>
                </el-form-item>
                <el-form-item label="费用总计" prop="sumMoney">
                    <el-input v-model="reqCreate.sumMoney" type="number" style="width:255px" clearable show-word-limit
                        placeholder="请输入费用总计"><template slot="append">元</template></el-input>
                </el-form-item>
                <el-form-item label="优惠后服务金额" prop="money" class="nian">
                    <el-input v-model="reqCreate.money" type="number" style="width:255px" clearable show-word-limit
                        placeholder="请输入优惠后服务金额（小于费用总计）">
                        <template slot="append">元</template></el-input>
                </el-form-item>

                <el-row>
                    <el-form-item label="甲方名称" prop="mingcheng">
                        <el-input v-model="reqCreate.mingcheng" style="width:255px" clearable show-word-limit
                            placeholder="请输入甲方名称"></el-input>
                    </el-form-item>
                    <el-form-item label="纳税号" prop="nashuihao">
                        <el-input v-model="reqCreate.nashuihao" style="width:255px" clearable show-word-limit
                            placeholder="请输入甲方纳税号"></el-input>
                    </el-form-item>
                    <el-form-item label="地址、电话" prop="dizhidianhua">
                        <el-input v-model="reqCreate.dizhidianhua" style="width:255px" clearable show-word-limit
                            placeholder="请输入地址、电话"></el-input>
                    </el-form-item>
                    <el-form-item label="开户行及账号" prop="kaihuhangzhanghao">
                        <el-input v-model="reqCreate.kaihuhangzhanghao" style="width:255px" clearable show-word-limit
                            placeholder="请输入开户行及账号"></el-input>
                    </el-form-item>

                    <el-form-item label="合同日期" prop="htrq">
                        <el-date-picker v-model="reqCreate.htrq" type="date" style="width:255px" placeholder="请选择合同签署日期"
                            value-format="yyyy-MM-dd" format="yyyy-MM-dd"></el-date-picker>
                    </el-form-item>

                </el-row>



            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="jcxy = false">取消</el-button>
                <el-button type="primary" @click="yulan()">预览合同</el-button>
            </span>
        </el-dialog>

        <el-dialog title="合同生成预览" :visible.sync="PDFVisible" :close-on-click-modal="false" width="900px" center>
            <iframe name="ifram11" :src="contractUrl" scrolling="auto" frameborder="0"
                style="width:870px;height:800px"></iframe>

            <span slot="footer" class="dialog-footer">
                <el-button @click="PDFVisible = false">取 消</el-button>
                <el-button type="primary" @click="sendContractBtn">发送合同</el-button>
            </span>
        </el-dialog>

    </div>
</template>
<script>
import contract from '@/script/api/contractapi';
import wmsApi from "@/script/api/wmsApi";
import globalData from '@/components/common/globaldata/global.data';
export default {
    data() {
        return {
            id: null,
            jcxy: false,
            PDFVisible: false,
            contractUrl: null,
            allJMSList: [],

            addField: {},
            singList: [],
            choosePerson: {}, //下拉框所选人
            rules: {
                signSealId: [{ required: true, message: "请选择签署公司", trigger: "blur" }],
                tel: [{ required: true, message: "请输入联系电话", trigger: "blur" }],
                xinyongdaima: [{ required: true, message: "请输入信用代码", trigger: "blur" }],
                address: [{ required: true, message: "请输入联系地址", trigger: "blur" }],
                dateStart: [{ required: true, message: "请选择服务开始时间", trigger: "change" }],
                dateEnd: [{ required: true, message: "请选择服务截至时间", trigger: "change" }],
                htrq: [{ required: true, message: "请选择合同签订日期", trigger: "change" }],
            },
            reqCreate: {
                xinyongdaima: '',
                htrq: '',

                "address": "",
                "collectAccount": "",
                "collectBankName": "",
                "collectUserName": "",
                "contractFileId": "",
                "contractNo": "",
                "createTime": "",
                "createUserId": '',
                "createUserName": "",
                dateEnd: "",
                dateStart: "",
                "feeDate": "",
                "fraId": '',
                "fraName": "",
                "id": '',
                "idCard": "",
                "jsonData": "",
                "processId": "",
                "remark": "",
                "signName": "",
                "signSealId": '',
                "state": '',
                "storeNumber": '',
                "tel": "",
                "templateNo": "",
                "type": '',
                nian: '',
                sumMoney: '',
                money: ''
            },
            city: ''
        };
    },
    methods: {
        showDetail(city) {
            this.getAllJMS();
            this.jcxy = true;
            this.city = city;
            this.reqCreate = {
                xinyongdaima: '',
                htrq: '',
                "address": "",
                "collectAccount": "",
                "collectBankName": "",
                "collectUserName": "",
                "contractFileId": "",
                "contractNo": "",
                "createTime": "",
                "createUserId": '',
                "createUserName": "",
                dateEnd: "",
                dateStart: "",
                "feeDate": "",
                "fraId": '',
                "fraName": "",
                "id": '',
                "idCard": "",
                "jsonData": "",
                "processId": "",
                "remark": "",
                "signName": "",
                "signSealId": '',
                "state": '',
                "storeNumber": '',
                "tel": "",
                "templateNo": "",
                "type": '',

                mingcheng: '',
                nashuihao: '',
                dizhidianhua: '',
                kaihuhangzhanghao: '',
            };

        },
        selectJms(id) {
            if (id == null || id == '') {
                this.choosePerson = {};
                this.reqCreate.fraId = "";
                this.reqCreate.xinyongdaima = "";
                this.reqCreate.tel = "";
                this.reqCreate.address = "";
            }
            if (id != null) {
                let ren = {};
                this.allJMSList.forEach(e => {
                    if (e.id == id) {
                        ren = e;
                    }
                })
                this.choosePerson = ren;
                this.reqCreate.fraId = ren.franchiseeId;
                this.reqCreate.xinyongdaima = ren.creditCode;
                this.reqCreate.tel = ren.tel;
                console.log(ren);
                this.reqCreate.address = ren.address;
            }
        },
        checkFm() {

            if (this.reqCreate.signSealId == null || this.reqCreate.signSealId == '') {
                this.$message.error('请选择签署公司');
                return false;
            }
            if (this.reqCreate.tel == null || this.reqCreate.tel == '' || this.reqCreate.tel.length != 11) {
                this.$message.error('请输入联电话，或输入正确的电话号码');
                return false;
            }
            if (this.reqCreate.xinyongdaima == null || this.reqCreate.xinyongdaima == '') {
                this.$message.error('请输入信用代码');
                return false;
            }

            if (this.reqCreate.address == null || this.reqCreate.address == '') {
                this.$message.error('请输入联系地址');
                return false;
            }

            if (this.reqCreate.dateStart == null || this.reqCreate.dateStart == ''
                || this.reqCreate.dateEnd == null || this.reqCreate.dateEnd == '') {
                this.$message.error('服务期限日期不能为空');
                return false;
            }

            if (this.reqCreate.htrq == null || this.reqCreate.htrq == '') {
                this.$message.error('请选择合同日期');
                return false;
            }

            return true;
        },
        fillTemplate() {
            let addField = {
                fraName: this.choosePerson.companyName,
                xinyongdaima: this.reqCreate.xinyongdaima,
                address: this.reqCreate.address,
                tel: this.reqCreate.tel,
                year: this.reqCreate.dateStart.substring(0, 4),
                month: this.reqCreate.dateStart.substring(5, 7) * 1,
                day: this.reqCreate.dateStart.substring(8, 10) * 1,
                zhi_year: this.reqCreate.dateEnd.substring(0, 4),
                zhi_month: this.reqCreate.dateEnd.substring(5, 7) * 1,
                zhi_day: this.reqCreate.dateEnd.substring(8, 10) * 1,
                // collectUserName: this.reqCreate.collectUserName,
                // collectAccount: this.reqCreate.collectAccount,
                // collectBankName: this.reqCreate.collectBankName,
                jia_year: this.reqCreate.htrq.substring(0, 4),
                jia_month: this.reqCreate.htrq.substring(5, 7) * 1,
                jia_day: this.reqCreate.htrq.substring(8, 10) * 1,
                yi_year: this.reqCreate.htrq.substring(0, 4),
                yi_month: this.reqCreate.htrq.substring(5, 7) * 1,
                yi_day: this.reqCreate.htrq.substring(8, 10) * 1,

                mingcheng: this.reqCreate.mingcheng,
                nashuihao: this.reqCreate.nashuihao,
                dizhidianhua: this.reqCreate.dizhidianhua,
                kaihuhangzhanghao: this.reqCreate.kaihuhangzhanghao,

                zhiding_tel: this.reqCreate.tel,
                zhidingren: this.choosePerson.faren,

                jia: '',
                yi: '',
                Contract_no: '',
                nian: this.reqCreate.nian,
                sumMoney: this.reqCreate.sumMoney,
                money: this.reqCreate.money
            };
            this.addField = addField;
            return addField;
        },
        yulan() {
            this.$refs['addForm'].validate(valid => {
                if (valid) {
                    let temFields = this.fillTemplate();
                    this.reqCreate.tempSignData = temFields;
                    let eventType = 202;
                    if (this.city == '苏州') {
                        eventType = 202
                    } else if (this.city == '杭州') {
                        eventType = 209
                    }else if (this.city == '宅景') {
                      eventType = 218
                    }
                    let reqData = {
                        // cityId: this.reqCreate.cityId,
                        fraId: this.reqCreate.fraId,
                        eventType: eventType,
                        name: '市场咨询服务合同',
                        simpleFormFields: temFields
                    };

                    const loading = this.$loading({
                        lock: true,
                        text: '努力生成中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.5)'
                    });

                    contract
                        .$ajaxPreviewFile(reqData)
                        .then((res) => {
                            if (res.data.errno == 0) {
                                loading.close();
                                // console.log(res);
                                this.contractUrl = res.data.data.downloadUrl;
                                this.reqCreate.templateNo = res.data.data.templateNo; //模板编号
                                this.reqCreate.contractNo = res.data.data.contractNo; //合同编号
                                this.reqCreate.contractFileId = res.data.data.fileId; //合同文件文件id
                                this.PDFVisible = true;
                            } else {
                                loading.close();
                                this.$message({
                                    showClose: true,
                                    message: res.data.data,
                                    type: 'warning',
                                    duration: 8000
                                });
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                }
            });
        },
        sendContractBtn() {
            const loading = this.$loading({
                lock: true,
                text: '发送合同中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });

            this.reqCreate.fraId = globalData.franchisee.id;
            this.reqCreate.createUserId = this.reqCreate.fraId;// globalData.userInfo.id;
            this.reqCreate.createUserName = globalData.userInfo.userName;
            if (this.city == '苏州') {
                this.reqCreate.type = 202;
            } else if (this.city == '杭州') {
                this.reqCreate.type = 209
            }else if (this.city == '宅景') {
              this.reqCreate.type = 218
            }


            contract.$ajaxJmsSignContract(this.reqCreate).then((res) => {
                loading.close();
                if (res.data.errno == 0) {
                    this.$message.success('合同已发送！');
                    // this.querySearch();
                    this.$emit('querySearch');
                    this.PDFVisible = false;
                    this.jcxy = false;
                } else {
                    this.$message.warning(res.data.data);
                }
            });
        },
        getAllJMS() {
            //城市下拉框
            contract
                .$ajaxJmsgetJMSAll()
                .then((res) => {
                    if (res.data.errno == 0) {
                        this.allJMSList = res.data.data;
                    }
                });
        },
    }
};
</script>
<style lang="">
.item .el-form-item__label{
    color:#f56c6c;
     font-weight:bold;
     font-size:10px
  }

  .nian .el-form-item__label{
     font-size:11px
  }
</style>
